<template>
  <c-sidebar :fixed="false" color-scheme="light">
    <c-button class="d-flex m-3" to="./compose" color="success">
      <c-icon name="cil-inbox" class="c-sidebar-nav-icon" />
      New Email
    </c-button>
    <c-sidebar-nav>
      <c-sidebar-nav-item to="./inbox" icon="cil-inbox" name="Inbox" :badge="{ text: 4, color: 'danger' }" />
      <c-sidebar-nav-item icon="cil-star" name="Stared" />
      <c-sidebar-nav-item icon="cil-paper-plane" name="Sent" />
      <c-sidebar-nav-item icon="cil-trash" name="Trash" />
      <c-sidebar-nav-item icon="cil-bookmark" name="Important" :badge="{ text: 5, color: 'info' }" />
      <c-sidebar-nav-item icon="cil-inbox" name="Spam" :badge="{ text: 42, color: 'warning' }" />
    </c-sidebar-nav>
  </c-sidebar>
</template>

<script>
export default {
  name: 'EmailNav',
};
</script>
